import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guards /mfa-setup (cc-9, B1).
 *
 * The route is reached two ways:
 *  1. A session-less enrolment entry via a hard backend 302 from the /authorize MfaSetup pause,
 *     carrying `continuation` + `setupToken` query params. Here the enrolment token in the URL IS
 *     the credential (mirroring /mfa-challenge, which has no guard at all), so admit the route even
 *     though no authenticated session exists yet — otherwise authGuard bounces the fresh SPA load
 *     back to /sign-in and re-creates the loop.
 *  2. The authenticated /sso and account-security method-switch entries, which have a real session.
 *     Here fall back to the existing authGuard behaviour (isAuthenticated() or bounce to /sign-in).
 */
export const mfaSetupGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const continuation = route.queryParamMap.get('continuation');
  const setupToken = route.queryParamMap.get('setupToken');
  const entryContinuation = route.queryParamMap.get('entryContinuationId');
  if ((continuation || entryContinuation) && setupToken) return true;

  if (authService.isAuthenticated()) return true;
  return router.createUrlTree(['/sign-in']);
};
